export default {
	danger: '#e53935',
	green: '#74863C',
	yellow: '#e7b032',
	swal: '#74863C',
	orange: '#FB8C00',
	blue: '#1976D2',
	orangeTable: '#FFCC80',
	greenTable: '#8BC34A',
	redTable: '#EF5350',
	blueTable: '#42A5F5',
	white: '#fff'
}